import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-task-create-task-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class ThirdpartyCreateApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Create New Third Party",
            description: "This endpoint can be used to create a new third party.",
            httpMethod: "POST",
            path: "/thirdparty",

            parameters: [
                {
                    name: "Name",
                    description: "Name of the third party to create",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "third party to create name",
                },
                {
                    name: "Description",
                    description: "Description of the third party to create",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "third party description",
                },
                {
                    name: "EUMember",
                    description:
                        "Is the third party to create a EU member. If omitted, defaults to false",
                    in: "body",
                    paramType: "boolean",
                    required: false,
                    example: true,
                },
                {
                    name: "LinkedRisks",
                    description: "Id's of the risks to be linked to the third party",
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "LinkedControls",
                    description: "Id's of the controls to be linked to the third party",
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "Address",
                    description: "Address of the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "1 example drive",
                },
                {
                    name: "ThirdPartyResponsible",
                    description: "The responsible for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Steve Responsible",
                },
                {
                    name: "CocNumber",
                    description: "The chamber of commerce number for the third party",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1234567890,
                },
                {
                    name: "TaxNumber",
                    description: "The tax number for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "taxnumberforthirdparty123",
                },
                {
                    name: "City",
                    description: "The city for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "cityofthirdparty",
                },
                {
                    name: "Country",
                    description: "The ISO 2 country code for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "NL",
                },
                {
                    name: "BeneficialOwner",
                    description: "The beneficial owner for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Dave Beneficialowner",
                },
                {
                    name: "AuthorizedSignatory",
                    description: "The authorized signatory for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Mark Authorizedsignatory",
                },
                {
                    name: "StatusOfInvolvementId",
                    description: "The status of involvement id to set on the third party",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "Email",
                    description: "The email to set on the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "thirdparty@thirdparty.com",
                },
                {
                    name: "Phone",
                    description: "The phone number to set on the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "0612345678",
                },
                {
                    name: "UserResponsibles",
                    description: "The user ids to set as responsible on the third party",
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "Website",
                    description: "The website for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "www.example.com",
                },
                {
                    name: "Comment",
                    description: "The comment for the third party",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "comment text",
                },
                {
                    name: "LeiCode",
                    description:
                        "The LEI code for the third party. Has to adhere to the ISO 17442 spec",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "529900T8BM49AURSDO55",
                },
                {
                    name: "DUNS_number",
                    description: "The DUNS number for the third party",
                    in: "body",
                    paramType: "long",
                    required: false,
                    example: 1234,
                },
                {
                    name: "OrganizationBeneficialOwner",
                    description:
                        "The Organization uuid to set as organization beneficial owner for the third party",
                    in: "body",
                    paramType: "uuid",
                    required: false,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "OrganizationResponsible",
                    description: "The Organization uuid to set as responsible for the third party",
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "EntityRoles",
                    description:
                        "The Data management roles to set for the third party, with the following options: None, DataController, DataProcessor, DataRecipient, ThirdParty. If omitted defaults to None",
                    in: "body",
                    paramType: "array of strings",
                    required: false,
                    example: ["DataController", "DataProcessor"],
                },
                {
                    name: "BusinessDimensions",
                    description: "The Business dimensions uuids to set for the third party",
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "FrameworkDimensions",
                    description: "The Framework dimensions uuids to set for the third party",
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "Organizations",
                    description: "The Organization uuids to set for the third party",
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "StartDateServicing",
                    description: "The start date servicing to set for the third party",
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-01-31",
                },
                {
                    name: "EndDateServicing",
                    description: "The end date servicing to set for the third party",
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-02-28",
                },
                {
                    name: "RelationshipId",
                    description: "The relationship to set for the third party",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "CriticalityId",
                    description: "The criticality to set for the third party",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "LinkedServiceIds",
                    description: "The id's for the services to set for the third party",
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [1, 2],
                },
                {
                    name: "CustomFields",
                    description:
                        "The custom fields to set for the third party. CustomFieldGuid and Value both are required. Value is always a string, but can represent a comma separated list of optionIds, a single optionId, an actual string, or a date value depending on the type of custom field being filled",
                    in: "body",
                    paramType: "array of models",
                    required: false,
                    example: [
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000000",
                            Value: "1,2",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000001",
                            Value: "1",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000002",
                            Value: "api custom field text",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000004",
                            DateValue: "2025-03-15",
                        },
                    ],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
